import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";

const GetTemplatesData = (data: any) => {
  if (!data || Object.keys(data).length === 0) {
    return Promise.resolve(null);
  }

  const queryParams = new URLSearchParams();

  if (data.searchText) queryParams.append("searchText", data.searchText);
  if (data.startDate) queryParams.append("startDate", data.startDate);
  if (data.endDate) queryParams.append("endDate", data.endDate);
  if (data.isActive !== undefined) queryParams.append("isActive", data.isActive);

  const url = `${ApiURL.Query.GetJsonTemplatesData}?${queryParams.toString()}`;

  return request({
    url,
    method: RequestType.GET,
  });
};

const GetTemplateById = (id: number) => {
  return request({
    url: `${ApiURL.Query.GetJsonTemplateById}/${id}`,
    method: RequestType.GET,
  });
};

const JsonBuilderServiceQuery = {
  GetTemplatesData,
  GetTemplateById,
};

export default JsonBuilderServiceQuery;
